/**
 * The decisions behind gated organizer pages: whether this viewer may open one,
 * and what an organizer reads instead when they haven't been granted it. Which
 * permission opens what is schemas/entitlements.json (generated into
 * ../models/generated/entitlements); a permission is a boolean on the
 * organizer's own grant, set by a super-admin on the Admins & Moderators page.
 * Pure, so the guard, the sidebar and the booth column share one tested answer.
 */
import { FEATURES, Feature, grantAllows } from '../models/generated/entitlements';

/** Super-admins open every report; an organizer, the ones their grant holds. */
export function canOpenFeature(
  isSuperAdmin: boolean,
  grant: Record<string, unknown> | null,
  feature: string,
): boolean {
  return isSuperAdmin || grantAllows(grant, feature);
}

/** "You don't have access to Sponsor ROI on this event." — the server's words too. */
export function accessRequiredMessage(feature: string | null | undefined): string {
  const f: Feature | undefined = feature ? (FEATURES as Record<string, Feature>)[feature] : undefined;
  return f
    ? `You don't have access to ${f.label} on this event.`
    : "You don't have access to this page on this event.";
}
